import {PlacesOfInteractionType} from '@optimaxdev/analytics/desktop/types/placeOfInteraction';
import {createAction, createReducer} from '@reduxjs/toolkit';

import {apiConfig} from 'libs/api/api';

import {setDataFromHostStore} from '../../actions';

type StateType = PlacesOfInteractionType | '';

export const initialState: StateType = '';

/**
 * Action for setting place of interaction
 */
export const setPlaceOfInteraction = createAction(
    'SET_PLACE_OF_INTERACTION',
    (payload: PlacesOfInteractionType) => {
        apiConfig.hostStore.dispatch({payload, type: 'SET_PLACE_OF_INTERACTION'});
        return {payload};
    },
);

/**
 * Action for clearing place of interaction
 */
export const clearPlaceOfInteraction = createAction('CLEAR_PLACE_OF_INTERACTION', () => {
    apiConfig.hostStore.dispatch({type: 'CLEAR_PLACE_OF_INTERACTION'});
    return {payload: ''};
});

/**
 * Get place of interaction
 *
 * @param {StateType} state - Current state
 * @param {<ActionType>} action - Received action
 * @returns {StateType} Cart quote data
 */
export const placeOfInteraction = createReducer<StateType>(initialState, builder =>
    builder
        .addCase(
            setDataFromHostStore,
            (state, action) => action.payload?.placeOfInteraction || state,
        )
        .addCase(setPlaceOfInteraction, (_, action) => action.payload)
        .addCase(clearPlaceOfInteraction, () => ''),
);
